import React, { useState, useEffect, useRef } from 'react';
import { getJoinInterviewersDetails, endMeetingForAll, interviewerGetMeetingEndedReason, approveAdmittingCandidate, checkIfCandidateTryToJoin, sendInterviewStartNotificationToCandidate } from '../../../../../services/util/interviews';
import { Col, Row, Container, Card, Form, Button } from 'react-bootstrap';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import CSSLoader from '../../../../shared/cssLoader';
import { CustomMessagePopUpBox } from '../../../../shared/customMessagePopUpBox';
import { Formik , ErrorMessage} from 'formik';
import styles from './InterviewView.module.scss';
import {
    BackgroundBlurProvider,
    VideoInputBackgroundBlurControl,
    useMeetingManager,
    MicSelection,
    SecondaryButton,
    CameraSelection,
    SpeakerSelection,
    PreviewVideo,
    PrimaryButton,
    Presenter,
    LeaveMeeting,
    AudioInputControl,
    VideoInputControl,
    AudioOutputControl,
    IconButton,
    Phone,
    Modal,
    ModalHeader,
    ModalBody,
    ModalButtonGroup,
    ModalButton,
    ContentShareControl,
    LocalVideo,
    useLocalVideo,
    useRemoteVideoTileState,
    RemoteVideo,
    ContentShare,
    useContentShareState,
    useMeetingStatus,
    useAttendeeStatus,
    useRosterState,
    RosterGroup,
    RosterAttendee,
    Attendees,
    Badge,
    Laptop,
    Chat,
    useAudioVideo,
    ChatBubble,
    ChatBubbleContainer
} from 'amazon-chime-sdk-component-library-react';
import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js';
import ReactGA from 'react-ga4';
import { boolean } from 'yup';
import { CustomConfirmationModal } from '../../../../shared/customConfirmationModal';
import { CustomButton } from '../../../../shared/customButton';
import { CustomTextArea } from '../../../../shared/customTextArea';
import ChatBox from '../../../../shared/chatBox';
import * as yup from 'yup';
import { backgroundColor } from 'styled-system';
const moment = require('moment');
require('moment-duration-format');

const InterviewView = (props) => {
    const { tiles, tileIdToAttendeeId,attendeeIdToTileId} = useRemoteVideoTileState();
    const [candidateTileID, setCandidateTileID] = useState(0);
    let { sharingAttendeeId, isLocalUserSharing } = useContentShareState();
    const { isVideoEnabled, toggleVideo, tileId } = useLocalVideo();
    const meetingManager = useMeetingManager();
    const meetingStatus = useMeetingStatus();
    const constraints = window.constraints = {
        audio: true,
        video: true
    };
    const audioVideo = useAudioVideo();
    let [chat_message, setChatMessage] = useState([]);
    let [numberOfMessages, setNumberOfMessages] = useState(0);


    let [meetingLoading, setMeetingLoading] = useState(false);

    const [loadingJoinInterview, setLoadingJoinInterview] = useState();
    const [loadingDeviceTest, setLoadingDeviceTest] = useState();
    const [startInterviewLoading, setStartInterviewLoading] = useState();
    const [deviceAccessError, setDeviceAccessError] = useState();
    const [showDeviceAccessErrorPopUp, setShowDeviceAccessErrorPopUp] = useState(false);
    const [showDeviceAccessSuccessPopUp, setShowDeviceAccessSuccessPopUp] = useState(false);
    const [showInterviewStartConstraintsPopUp, setShowInterviewStartConstraintsPopUp] = useState(false);
    const [showMeetingEndedMsgPopup, setShowMeetingEndedMsgPopup] = useState(false);
    const [showMeetingEndedDueToExternalLinkPopup, setShowMeetingEndedDueToExternalLinkPopup] = useState(false);
    const [showJoinInterviewErrorPopUp, setShowJoinInterviewErrorPopUp] = useState(false);
    let [showLeaveOrEndMeetingConfirmationPopup, setShowLeaveOrEndMeetingConfirmationPopup] = useState(false);

    let [meetingEndedByThisUser, setMeetingEndedByThisUser] = useState(false);


    let [localAttendeeId, setLocalAttendeeId] = useState();
    let [selectedAttendeeId, setSelectedAttendeeId] = useState();
    let [joinMeetingLoading, setJoinMeetingLoading] = useState(false);
    let [viewID, setViewID] = useState(1);
    let [selectedTileID, setSelectedTileID] = useState(null);
    let [cancelMeeting, setCancelMeeting] = useState(false);
    let [isInterviewStartGracePeriodPassed, setIsInterviewStartGracePeriodPassed] = useState(false);
    let [currentDateAndTime, setcurrentDateAndTime] = useState();
    let [sheduledDateAndTime, setsheduledDateAndTime] = useState();
    let [differenceBetweenScheduleAndCurrentTimeInMinutes, setDifferenceBetweenScheduleAndCurrentTimeInMinutes] = useState();
    let [durationTime, setdurationTime] = useState();
    let [isInterviewSheduleExpired, setIsInterviewSheduleExpired] = useState(false);
    let [applicationMeetingStatus, setAppicationMeetingStatus] = useState(0);
    let { videoEnabled } = useAttendeeStatus(selectedAttendeeId);
    let [isCandidateWaitingToJoin, setIsCandidateWaitingToJoin] = useState(false);

    const { roster } = useRosterState();
    const attendees = Object.values(roster);
    const [sidebarRosterType, setSidebarRosterType] = useState(1);
    let [showControls, setShowControls] = useState(false);
    const fullScreenHandler = useFullScreenHandle();
    const [show, setShow] = useState(true);
    let [isVideoIconClicked, setIsVideoIconClicked] = useState(false);
    const [showReloadModal,setShowReloadModal] = useState(false);
    let [connectionIssueMessage, setConnectionIssueMessage] = useState(0);
    const reloadTimeoutRef = useRef(null);
    const messageTimeoutRef = useRef(null);

    const showPreviewVideo = () => {
        setShow(!show);
        
    };


    const getInitialsFromName = (name) => {
        const nameArray = name.split(' ');
        const initials = nameArray.slice(0, 2).map(n => n[0]).join('');
        return initials.toUpperCase();
    };
    
    const attendeeItems = attendees.map((attendee, index) => {
        const { chimeAttendeeId, name, externalUserId } = attendee;
        let string = externalUserId;
        let result = string.split(/-(.+)/);
        let value = result[1];
        return (
            <div className={styles.atedeewrap}>
                {(!(isVideoEnabled && (chimeAttendeeId === localAttendeeId))) && (
                    !attendeeIdToTileId[chimeAttendeeId] && (
                        <div className={styles.relativeDiv}>
                            <div className={styles.nameLogo}>
                                {getInitialsFromName(value)}
                            </div>
                            <div className={styles.absoluteDiv}>
                                <RosterAttendee key={chimeAttendeeId} attendeeId={chimeAttendeeId} name={value} subtitle={value===props.candidateName?'Candidate':'Reviewer'} />
                            </div>
                        </div>
                    )
                )}

            </div>

        );
    });
    
    
    let numberOfAttendees = attendees.length;

    const schema = yup.object({
        message: yup.string().trim().required().max(1000, 'Maximum 1000 characters allowed')
    });

    const getAttendeeId = (titleId) => {
        const attendeeId = (tileIdToAttendeeId[titleId]).toString();
        return (attendeeId)
    }

    //get candidate name using remote video tile id
    const getAttendeeName = (titleId) => {
        const attendeeId = (tileIdToAttendeeId[titleId])?.toString();
        if (attendeeId) {
            const string = roster[attendeeId];
            let result = string? string.externalUserId.split(/-(.+)/) : '';
            return result[1];
        } else {
            return 0; //when candidat off cammera return 0 value one time.
        }

    }
    const getLoaclAttedndeedName = (attendeeId) => {
        const clearAttendeeId = attendeeId.split('#')[0];
        if(clearAttendeeId){
            const string = roster[clearAttendeeId];
            let result = string? string.externalUserId.split(/-(.+)/): '';
            return result[1];
        }else {
            return 0; //when candidat accidentaly close tab return 0 value.
        }
        
    }


    const triggerMeetingEndedAcknowledgementPopup = async () => {
        let respond = await interviewerGetMeetingEndedReason(props.sessionID);
        if (respond.success === true && respond.data.ended_due_to_external_meeting) {
            setShowMeetingEndedDueToExternalLinkPopup(true); // show external meeting shared msg popup
        } else {
            setShowMeetingEndedMsgPopup(true); // show meeting ended msg popup
        }
    }
    const playCandidateJoiningRequestAlert = () => {
        const audioPath = process.env.PUBLIC_URL + '/sounds/interview-candidate-joining-request-alert.wav';
        const audio = new Audio(audioPath);
        audio.play();
      };
    
      const checkIfCandidateWaitingToJoin = async () => {

        let respond = await checkIfCandidateTryToJoin(props.sessionID);
        if (respond.data.is_interviewers_approved_admitting_candidate) {
            setIsCandidateWaitingToJoin(false);
        } else if (respond.data.candidate_try_to_join) {
            playCandidateJoiningRequestAlert(); // Play sound continuously
            setIsCandidateWaitingToJoin(true);
            setTimeout(checkIfCandidateWaitingToJoin, 5000); // Check again in 5 seconds
        } else {
            setTimeout(checkIfCandidateWaitingToJoin, 5000); // Check again in 5 seconds
        }
    };
    

    const approvingAdmittingCandidate = async () => {
        await approveAdmittingCandidate(props.sessionID);
        setIsCandidateWaitingToJoin(false);
    };
    
    
    if (applicationMeetingStatus !== meetingStatus) {
        setAppicationMeetingStatus(meetingStatus)
        if (meetingStatus === 1) {
            setViewID(3);
            setJoinMeetingLoading(false)
            checkIfCandidateWaitingToJoin();
        }
        else if (meetingStatus === 3 && !meetingEndedByThisUser) {
            triggerMeetingEndedAcknowledgementPopup();
        }
        else if (meetingStatus == 2 || meetingStatus == 6) {
            setJoinMeetingLoading(false)
        }

    }

    //check if interview expired or have more time to schedule 
    const checkInterviewStartConstraints = () => {
        //get props values
        const sheduledDateTime = props.sheduleTime.date_time
        const timeZone = props.sheduleTime.time_zone

        //get current time
        let nowObj = moment().tz(timeZone);

        //convert sheduledtime to moment object
        let shedlued = moment.tz(sheduledDateTime, timeZone)

        //convert current date and time, sheduled time to readable manner
        let currentDateAndTime = moment(nowObj).format('LLLL');
        let sheduledDateAndTime = moment(shedlued).format('LLLL');
        setcurrentDateAndTime(currentDateAndTime);
        setsheduledDateAndTime(sheduledDateAndTime);

        let current_time_utc = moment().utc();
        let scheduled_time_utc = moment(sheduledDateTime);

        let time_difference = parseInt(moment.duration(scheduled_time_utc.diff(current_time_utc)).asMinutes());
        setDifferenceBetweenScheduleAndCurrentTimeInMinutes(time_difference);

        //check sheduled date is passed
        let isInterviewSheduleExpired = shedlued < nowObj;


        setIsInterviewSheduleExpired(isInterviewSheduleExpired);

        if (isInterviewSheduleExpired) {

            let timeDiff = nowObj.diff(shedlued,'minutes');

            if (timeDiff > 45) {
                setIsInterviewStartGracePeriodPassed(true);
            }
        }
        //get time difference from two dates
        var timeDifference = moment.duration(nowObj.diff(shedlued));
        let durationTime = timeDifference.format("w [weeks],d [days],h [hours], m [minutes]");
        let durationTimeFinal = durationTime.replace('-', '');
        setdurationTime(durationTimeFinal)

        setShowInterviewStartConstraintsPopUp(true);
    }

    const closeInterviewStartConstraintsPopups = () => {
        setShowInterviewStartConstraintsPopUp(false);
    }

    const joinMeeting = async () => {
        setStartInterviewLoading(true);
        setMeetingLoading(true);
        setMeetingEndedByThisUser(false);
        // Fetch the meeting and attendee data from your server
        let respond = await getJoinInterviewersDetails(props.sessionID);
        if (respond.success === true && respond.data && respond.data.meeting && respond.data.attendee) {
            
            const id = respond.data.attendee.Attendee.AttendeeId.toString();
            await setLocalAttendeeId(id)
            // Use the join API to create a meeting session
            const meetingSessionConfiguration = new MeetingSessionConfiguration(respond.data.meeting, respond.data.attendee);
            await meetingManager.join(meetingSessionConfiguration);

            setShowInterviewStartConstraintsPopUp(false);
            setStartInterviewLoading(false);
            setMeetingLoading(false);
            setViewID(2);
        } else if (respond.success === true && respond.data && respond.data.already_ended_due_to_external_meeting) {

            setShowMeetingEndedDueToExternalLinkPopup(true);
            setShowInterviewStartConstraintsPopUp(false)
            setStartInterviewLoading(false);
            setMeetingLoading(false);
        }
        else {
            setStartInterviewLoading(true);
            setMeetingLoading(false);
            openJoinInterviewErrorPopup()
        }
    };

    const openJoinInterviewErrorPopup = () => {
        setShowJoinInterviewErrorPopUp(true);
    }

    const closeJoinInterviewErrorPopup = () => {
        setShowJoinInterviewErrorPopUp(false);
        window.location.reload();
    }

    const startMeeting = async () => {
        let response = await sendInterviewStartNotificationToCandidate(props.sessionID);

        if (response.success === true) {
            await meetingManager.start();
            setJoinMeetingLoading(true);
        } 
    }

    const leaveMeeting = async () => {
        setMeetingLoading(true);
        await meetingManager.leave();
        setMeetingLoading(false);
        setShowLeaveOrEndMeetingConfirmationPopup(false);
        setViewID(1);
    }

    const endMeeting = async (id) => {
        setCancelMeeting(true);
        setMeetingLoading(true);
        setMeetingEndedByThisUser(true);
        let respond = await endMeetingForAll(id);
        if (respond.success === true) {
            setCancelMeeting(false)
            await meetingManager.leave();
            setMeetingLoading(false);
            setShowLeaveOrEndMeetingConfirmationPopup(false)
            setViewID(1);
        } else {
            setCancelMeeting(false)
            setMeetingLoading(false);
        }
    
    }

    // refresh page either meeting ended or external meeting shared
    const meetingEndedMsgAcknowledgement = () => {
        setShowMeetingEndedDueToExternalLinkPopup(false);
        setShowMeetingEndedMsgPopup(false);
        setMeetingEndedByThisUser(false);
        window.location.reload();
    }

    const endSession = () => {
        setShowLeaveOrEndMeetingConfirmationPopup(true);
    }

    // check if browser permissions enabled to access camera and mic
    const CheckDeviceAccess = (check_and_join_meeting) => {

        if (check_and_join_meeting) {
            setLoadingJoinInterview(true);
        }
        else {
            setLoadingDeviceTest(true);
        }
        navigator.mediaDevices.getUserMedia(constraints).then(function success(stream) {
            // if user clicked Join interview option
            if (check_and_join_meeting) {
                checkInterviewStartConstraints();
                setLoadingJoinInterview(false);
            } else { //else, just show the permission ok message
                setShowDeviceAccessSuccessPopUp(true)
                setLoadingDeviceTest(false);
            }

        }).catch(function (err) {
            if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
                setDeviceAccessError("Camera or Microphone not found");
                setShowDeviceAccessErrorPopUp(true);
            } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
                setDeviceAccessError("Microphone or Camera already in use by a different application ");
                setShowDeviceAccessErrorPopUp(true);
            } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
                setDeviceAccessError("Microphone or Camera permissions denied in browser ");
                setShowDeviceAccessErrorPopUp(true);
            } else {
                setDeviceAccessError("Failed to connect with Microphone or Camera. Please try again later");
                setShowDeviceAccessErrorPopUp(true);
            }
            setLoadingDeviceTest(false);
        });
    }

    const closeDeviceAccessTestPopups = () => {
        setShowDeviceAccessSuccessPopUp(false);
        setShowDeviceAccessErrorPopUp(false);
        setLoadingJoinInterview(false);
        setDeviceAccessError(null)
    }


    const updateSelectedAtendeeStatus = (tileid) => {
        if (!tileid || (tileid === '-2')) {
            setSelectedAttendeeId(null)
        }
        else if (tileid === '-1') {
            setSelectedAttendeeId(localAttendeeId)
            setSelectedAttendeeId(localAttendeeId)
        }
        else {
            const id = (tileIdToAttendeeId[tileid])?.toString();
            setSelectedAttendeeId(id)
            setSelectedAttendeeId(id)
        }
    }

    const viewControls = () => {
        setShowControls(true)
        let timeout;
        (() => {
            clearTimeout(timeout);
            timeout = setTimeout(() => setShowControls(false), 3500);
        })();
    }

    //send chat message
    const sendChatData = (text, { resetForm }) => {
        const mess = {
            action: 'outgoing',
            cmd: "TEXT",
            data: text.message,
            createdDate: moment().format('hh:mm A'),
            senderName: localStorage.getItem('name')
        }
        audioVideo.realtimeSendDataMessage('chat', JSON.stringify(mess));
        resetForm({ message: '' });
        setChatMessage([...chat_message, mess])
    }

    //chat message receive
    const receiveChatData = (mess) => {
        if (sidebarRosterType !== 3) {
            let count = numberOfMessages + 1;
            setNumberOfMessages(count);
        }
        const data = JSON.parse(mess.text());
        data.action = 'incoming';
        setChatMessage([...chat_message, data]);
    }

    //chat button clicked method
    const handleClickChatButton = async () => {
        await setSidebarRosterType(2)
        setNumberOfMessages(0);
        scrollDownChat();

    }
    
    //attendee button clicked method
    const handleClickAttendeeButton = () => {
        setSidebarRosterType(1)
        setNumberOfMessages(0);
    }

    //chat data useEffect
    useEffect(() => {
        if (audioVideo) {
            audioVideo.realtimeSubscribeToReceiveDataMessage(
                'chat',
                receiveChatData
            );

            return () => {
                audioVideo.realtimeUnsubscribeFromReceiveDataMessage('chat');
            }
        }

    }, [audioVideo, chat_message, numberOfMessages, sidebarRosterType])

    useEffect(() => {
        if (sidebarRosterType === 3) {
            setNumberOfMessages(0);
        }
    }, [sidebarRosterType]);


    useEffect(() => {
        setSelectedAttendeeId(null);
        setSelectedTileID(null)
    }, [videoEnabled]);

     //for video on/off handler
     const handleVideoToggle = () => {
        setIsVideoIconClicked(true);
        toggleVideo();
    }

    useEffect(() => {
        if (!isVideoEnabled && meetingStatus === 1 && !isVideoIconClicked) {
            toggleVideo();
        }
    }, [isVideoEnabled, meetingStatus]);


    useEffect(
        () => {
            return () => {
                leaveMeeting();
            };
        },
        [props.isLeaving],
    );

    useEffect(() => {
        let pageHit = '/app/company/interview-review';
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, []);

    const chatContainerRef = useRef(null);

    const scrollDownChat = () => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }

    useEffect(() => {
        scrollDownChat();
    }, [chat_message]);

    useEffect(() => {
        const findCandidateTileID = () => {
            attendees.forEach(attendee => {
                const { chimeAttendeeId, externalUserId } = attendee;
                let string = externalUserId;
                let result = string.split(/-(.+)/);
                let value = result[1];
                if (value === props.candidateName) {
                    setCandidateTileID(attendeeIdToTileId[chimeAttendeeId]);
                }else{
                    setCandidateTileID(0);
                }

            });
        };
        findCandidateTileID();
    }, [attendees, props.candidateName, attendeeIdToTileId]);

    useEffect(() => {
        updateSelectedAtendeeStatus(candidateTileID);
        setSelectedTileID(candidateTileID);
    }, [candidateTileID]);

    useEffect(() => {
        if(sharingAttendeeId){
            updateSelectedAtendeeStatus('-2');
            setSelectedTileID('-2');
        }     
    }, [sharingAttendeeId]);

    useEffect(() => {
        if (meetingStatus === 7) {
            setConnectionIssueMessage(10);
            setShowReloadModal(true);
            // Clear any existing timeouts
            if (reloadTimeoutRef.current) {
                clearTimeout(reloadTimeoutRef.current);
            }
            if (messageTimeoutRef.current) {
                clearTimeout(messageTimeoutRef.current);
            }
            
            // Change Message after 1 minute
            messageTimeoutRef.current = setTimeout(() => {
                setConnectionIssueMessage(20);
            }, 60000); // 1 min

            // Set a timeout to reload the page after 2 minutes
            reloadTimeoutRef.current = setTimeout(() => {
                window.location.reload();
            }, 120000); // 2 min
        } else if (meetingStatus === 1) {
            setShowReloadModal(false);
            // Clear the timeouts if meetingStatus changes to 1
            if (reloadTimeoutRef.current) {
                clearTimeout(reloadTimeoutRef.current);
                reloadTimeoutRef.current = null;
            }
            if (messageTimeoutRef.current) {
                clearTimeout(messageTimeoutRef.current);
                messageTimeoutRef.current = null;
            }
        }

        // Clean up the timeouts when the component unmounts or meetingStatus changes
        return () => {
            if (reloadTimeoutRef.current) {
                clearTimeout(reloadTimeoutRef.current);
            }
            if (messageTimeoutRef.current) {
                clearTimeout(messageTimeoutRef.current);
            }
        };
    }, [meetingStatus]);


    return (
        <BackgroundBlurProvider>
        <div>
            {
                showLeaveOrEndMeetingConfirmationPopup && (
                    <Modal size="md" onClose={() => setShowLeaveOrEndMeetingConfirmationPopup(false)} rootId="modal-root">
                        <ModalHeader title="End Meeting" />
                        <ModalBody>
                            <p>Leave meeting or you can end the meeting for all. The meeting cannot be used once it ends.</p>
                            <ModalButtonGroup
                                primaryButtons={[
                                    <div>
                                        <ModalButton onClick={leaveMeeting} label="Leave Meeting" variant="primary" key="leaveMeeting" disabled={meetingLoading === true ? true : false} />
                                        <ModalButton onClick={() => { endMeeting(props.sessionID) }} label="End meeting for all" variant="primary" key="endMeeting"
                                            icon={cancelMeeting === true ? <i className="fas fa-spinner fa-spin"></i> : null}
                                            disabled={cancelMeeting === true ? true : false}
                                        />
                                    </div>
                                ]}
                                secondaryButtons={[
                                    <ModalButton
                                        onClick={() => setShowLeaveOrEndMeetingConfirmationPopup(false)}
                                        label="Cancel"
                                        key="cancelBtn"
                                        variant="secondary"
                                    />
                                ]}
                            />
                        </ModalBody>
                    </Modal>
                )
            }
            {/* Reload popup */}
            {showReloadModal && (
                <div>
                    <div className={styles.connctionIssueModal}>
                        <div className={styles.innerConnctionIssueModal}>
                        <p className={connectionIssueMessage === 20? styles.connctionIssueTitle20 : styles.connctionIssueTitle10 }>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.3119 10C16.6802 10.4263 17.9624 11.1191 19.08 12.05M22.5799 8.49997C19.6575 5.92394 15.8956 4.50262 11.9999 4.50262C11.3949 4.50262 10.7931 4.5369 10.1972 4.60447M8.52979 15.61C9.54499 14.8888 10.7595 14.5013 12.0048 14.5013C13.2501 14.5013 14.4646 14.8888 15.4798 15.61M12 19.5H12.01M1.19336 8.70076C2.52697 7.47869 4.06839 6.47975 5.75851 5.76306M4.73193 12.243C6.12934 11.012 7.84172 10.1302 9.73265 9.73393M15.6983 15.7751C14.6792 14.9763 13.3952 14.5 11.9999 14.5C10.5835 14.5 9.28172 14.9908 8.25537 15.8116M3 3L21 21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span>Connection Issue.</span>
                                </p>
                                <p className={styles.connctionIssueText}>{connectionIssueMessage === 20? 'There is a connectivity issue. Please check your internet connection and refresh the page.':connectionIssueMessage === 10?'The interview has detected network connection issues, Please hold on.':'' }</p>
                                <div class={styles.connectionLoader}></div>
                        </div>
                    </div>
                </div>
             )  
             }
            {/* device access success popup */}
            <CustomMessagePopUpBox
                show={showDeviceAccessSuccessPopUp}
                confirmationType='success'
                cancelIconclick={() => { closeDeviceAccessTestPopups() }}
                onPrimaryBtnClick={() => { closeDeviceAccessTestPopups() }}
                topic="Test Successful"
                message="No issues detected. Both Microphone and Camera work properly"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Ok!"
                is_a_success_message={true}
            />
            {/* device access error popup */}
            <CustomMessagePopUpBox
                show={showDeviceAccessErrorPopUp}
                confirmationType='danger'
                cancelIconclick={() => { closeDeviceAccessTestPopups() }}
                onPrimaryBtnClick={() => { closeDeviceAccessTestPopups() }}
                topic="Test Failed"
                message={deviceAccessError}
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Ok!"
                isExternalLinkAvailable={true}
                externalLinkLable="Learn how to enable permissions."
                externalLink="https://hiretrace.io/documentation/interviews/browser-permissions"
            />

            {/* start interview alert confirmation start */}
            <CustomConfirmationModal
                show={showInterviewStartConstraintsPopUp}
                confirmationType='success'
                cancelIconclick={() => closeInterviewStartConstraintsPopups()}
                onSecondaryBtnClick={() => closeInterviewStartConstraintsPopups()}
                onPrimaryBtnClick={joinMeeting}
                showToolTip={((differenceBetweenScheduleAndCurrentTimeInMinutes > 5) || isInterviewStartGracePeriodPassed) ? true : false}
                toolTipId='interview_constaints_tip_id'
                toolTip={(differenceBetweenScheduleAndCurrentTimeInMinutes > 5) ? 'Too early to start the interview' : 'Scheduled time is passed by 45mins.'}
                isPrimaryBtnDisabled={((isInterviewStartGracePeriodPassed) || (differenceBetweenScheduleAndCurrentTimeInMinutes > 5) || startInterviewLoading) ? true : false}
                isSecondaryBtnDisabled={startInterviewLoading ? true : false}
                primaryBtnBackSideIcon={startInterviewLoading ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                confirmationTopic="Are you sure?"
                secondaryBtnName="backBtn"
                secondaryBtnType="button"
                secondaryBtnCssType="primaryBtn"
                secondaryBtnLabel="Cancel"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="successBtn"
                primaryBtnLabel="Start"
                confirmationMessage={
                    <div>
                        <Container  className='ps-0 ms-0'>
                            <div className={styles.alertLabelDiv}>
                            <div className={styles.timeDiv}>
                            <div>
                            <p className={styles.alertLabelsLeft}>Interview scheduled date and time<br /><span className={styles.alertValues}>{sheduledDateAndTime}</span><br /><span className={styles.alertValues}>({props.sheduleTime.time_zone})</span></p><br />
                            </div>
                            <div className='ms-3'>
                            <p className={styles.alertLabels}>Current date and time<br /><span className={styles.alertValues}>{currentDateAndTime}</span><br /><span className={styles.alertValues}>({props.sheduleTime.time_zone})</span></p><br />
                            </div>
                            </div>
                            {isInterviewSheduleExpired === false && isInterviewStartGracePeriodPassed === false &&
                                <div>
                                    <p className={styles.alertLabels}>To start interview you have <span className={styles.boldValues}>{durationTime}</span>.</p><br />
                                    <p className={styles.alertLabelsWarning}>{(differenceBetweenScheduleAndCurrentTimeInMinutes > 5) ? 'Cannot start the interview yet. Interview Start option will be enabled 5mins before the scheduled time' : 'Do you want to start the interview now?'}</p>
                                </div>
                            }

                            {isInterviewSheduleExpired === true && isInterviewStartGracePeriodPassed === false &&
                                <p className={styles.alertLabelsWarning}>You have missed your interview time by <span className={styles.alertValuesWarning}>{durationTime}</span>. But still you can start the interview</p>
                            }
                            {isInterviewSheduleExpired === true && isInterviewStartGracePeriodPassed === true &&
                                <p className={styles.alertLabelsDanger}>You have missed your interview time by <span className={styles.alertValuesDanger}>{durationTime}</span>. So you cannot start this interview. Please reschedule</p>
                            }
                            </div>
                        </Container>
                    </div>
                }
            />
            {/* interview ended msg popup */}
            {
                <CustomMessagePopUpBox
                    show={showMeetingEndedMsgPopup}
                    confirmationType='default'
                    cancelIconclick={() => { meetingEndedMsgAcknowledgement() }}
                    onPrimaryBtnClick={() => { meetingEndedMsgAcknowledgement() }}
                    topic="Interview Ended"
                    message={"This interview has been ended by another interviewer"}
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnCssType="successBtn"
                    primaryBtnLabel="Ok!"
                />
            }
            {/* external meeting link shared msg popup */}
            {
                <CustomMessagePopUpBox
                    show={showMeetingEndedDueToExternalLinkPopup}
                    confirmationType='default'
                    cancelIconclick={() => { meetingEndedMsgAcknowledgement() }}
                    onPrimaryBtnClick={() => { meetingEndedMsgAcknowledgement() }}
                    topic="An Alternative Meeting URL Shared"
                    message={"An alternative meeting url is shared. Please click 'Ok' to refresh the page and get updated interview joining details"}
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnCssType="successBtn"
                    primaryBtnLabel="Ok!"
                />
            }
            {/* Error during joining the interview */}
            <CustomMessagePopUpBox
                show={showJoinInterviewErrorPopUp}
                confirmationType='danger'
                cancelIconclick={() => closeJoinInterviewErrorPopup()}
                onPrimaryBtnClick={() => closeJoinInterviewErrorPopup()}
                topic="Something went Wrong !"
                message="Error occured when connecting you to the interview. Please contact support@hiretrace.io"
                primaryBtnName="submitBtn"
                primaryBtnType="button"
                primaryBtnCssType="dangerBtn"
                primaryBtnLabel="Ok!"
            />


            <div>
                {viewID === 1 ? //Test Audio/Video
                    (<Row className={styles.buttonContainingRow}>
                        <SecondaryButton
                            label="Test Audio/Video"
                            id="adminPanel_interviews_singleInterview_interviewView_testAudioVideoBtnId"
                            onClick={() => CheckDeviceAccess(false)}
                            icon={loadingDeviceTest === true ? <i className="fas fa-spinner fa-spin"></i> : null}
                            className={styles.customButton}
                            disabled={loadingDeviceTest === true ? true : false}
                        />

                        <SecondaryButton
                            label="Start / Join Interview"
                            id="adminPanel_interviews_singleInterview_interviewView_startInterviewBtnId"
                            onClick={() => CheckDeviceAccess(true)}
                            icon={loadingJoinInterview === true ? <i className="fas fa-spinner fa-spin"></i> : null}
                            className={styles.customPrimaryButton}
                            disabled={loadingJoinInterview === true ? true : false}
                        />
                    </Row>)
                    : viewID === 2 ? //audio and video setup view
                        (
                            <div>
                                <Container className={styles.cameraPreviewContainer}>
                                    <Row>
                                        <Col sm={6} className={styles.audioDiv}>
                                            <div className={styles.dropdownItemContainerColumn}>
                                                <p className={styles.topicLabel}>Choose your video and audio options</p>
                                                <div>
                                                    <MicSelection/>
                                                </div>
                                                <div>
                                                    <SpeakerSelection/>
                                                </div>
                                                <div>
                                                    <CameraSelection/>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm={6}>
                                            <div className={styles.dropdownItemContainerColumnRight}>
                                                <div>
                                                    <p className={styles.topicLabelPreviewVideo}>Video Preview</p>
                                                    <div className={styles.PreviewVideo}>
                                                        {show ? (
                                                            <PreviewVideo className={styles.noPreviewViedo}/>
                                                        ) : (
                                                                <div className={styles.noPreviewViedo}>
                                                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M5 5C3.34315 5 2 6.34315 2 8V16C2 17.6569 3.34315 19 5 19H14C15.3527 19 16.4962 18.1048 16.8705 16.8745M17 12L20.6343 8.36569C21.0627 7.93731 21.2769 7.72312 21.4608 7.70865C21.6203 7.69609 21.7763 7.76068 21.8802 7.88238C22 8.02265 22 8.32556 22 8.93137V15.0686C22 15.6744 22 15.9774 21.8802 16.1176C21.7763 16.2393 21.6203 16.3039 21.4608 16.2914C21.2769 16.2769 21.0627 16.0627 20.6343 15.6343L17 12ZM17 12V9.8C17 8.11984 17 7.27976 16.673 6.63803C16.3854 6.07354 15.9265 5.6146 15.362 5.32698C14.7202 5 13.8802 5 12.2 5H9.5M2 2L22 22" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </div>
                                                        )}
                                                        </div>
                                                    <div className={styles.previewVideoConrols}>
                                                    <VideoInputBackgroundBlurControl onClick={showPreviewVideo} />
                                                    <AudioInputControl/>
                                                    </div>
                                                </div>
                                            </div>
                                            {!props.isInterviewStartedNotifiedEmailReceived &&
                                                <div className={styles.interviewStartMsg}>
                                                    <CustomAlertBox
                                                        alertType='defaultAlert'
                                                        alertBodyText='When you click "Join Meeting", the candidate will receive an interview started email notification'
                                                    />
                                                </div>
                                            }

                                                <div className={styles.actionRowPreview}>
                                                    <SecondaryButton label="Leave Meeting" disabled={meetingLoading === true && viewID === 2 ? true : false} icon={meetingLoading === true && viewID === 2 ? <i className="fas fa-spinner fa-spin"></i> : <LeaveMeeting />} onClick={leaveMeeting} />
                                                    <PrimaryButton label='Join Meeting' disabled={(joinMeetingLoading === true && viewID === 2 && applicationMeetingStatus === 0) ? true : false} icon={(joinMeetingLoading === true && viewID === 2 && applicationMeetingStatus === 0) ? <i className="fas fa-spinner fa-spin"></i> : <Presenter />} onClick={startMeeting} />
                                                </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        )
                        : viewID === 3 ? //online Interview view

                            (<div>
                                <Row className={styles.videoPosition}>
                                    {/* middle video/screen share component */}
                                    <Col className={styles.mainVideoBackgroundCol} onMouseMove={() => viewControls()}>
                                        <Card className={styles.mainVideoBackgroundCard}>
                                            <Card.Body className={styles.mainVideoBackground} onMouseMove={() => viewControls()}>
                                                <FullScreen handle={fullScreenHandler} className={styles.fullscreenContainer}>
                                                    {(!!selectedTileID && (selectedTileID !== '-1') && (selectedTileID !== '-2')) &&
                                                        <RemoteVideo name={getAttendeeName(selectedTileID)} tileId={selectedTileID} />
                                                    }
                                                    {(!!selectedTileID && (selectedTileID == '-1') && isVideoEnabled) &&
                                                        <LocalVideo nameplate={getLoaclAttedndeedName(localAttendeeId)} />
                                                    }
                                                    {(!!selectedTileID && (selectedTileID == '-2') && !!sharingAttendeeId) &&
                                                        <ContentShare nameplate={getLoaclAttedndeedName(sharingAttendeeId)}/>
                                                    }

                                                    {/* show controllers in full screen mode */}
                                                    {fullScreenHandler.active === true &&
                                                        <Col xs={4} className={showControls === true ? `${styles.buttonRowOutlineHover} ${styles.showcontrols}` : styles.buttonRowOutlineHover}>
                                                            <Row >
                                                                <div className={styles.actionBtnInnerRow}>
                                                                <AudioInputControl />
                                                                <AudioOutputControl />
                                                                <VideoInputBackgroundBlurControl onClick={handleVideoToggle}  />
                                                                <div onClick={() => { setSelectedTileID('-2') }}><ContentShareControl /></div>
                                                                <IconButton
                                                                    icon={<i className="fas fa-compress-arrows-alt"></i>}
                                                                    onClick={fullScreenHandler.exit}
                                                                    className={styles.videoTileBtn}
                                                                />
                                                                </div>
                                                            </Row>
                                                        </Col>
                                                    }
                                                </FullScreen>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col sm={3} className={styles.rosterSide} id={styles.rosterid}>
                                        {/*video tiles & participant list */}
                                        {sidebarRosterType === 1 ?
                                            <Row className={styles.tileOuterBox}>
                                                <div className='mx-0 px-0'>
                                                    {isCandidateWaitingToJoin &&
                                                        <div className={styles.waitingRoom}>
                                                            <p className={styles.waitingRoomTxt}>Waiting Room</p>
                                                            <div>
                                                                <Col className={styles.candidateAdmitCol}>
                                                                    <Row className={styles.candidateName} ><p>{props.candidateName}</p></Row>
                                                                    <Row className={styles.admitBtn}>
                                                                        <Button
                                                                            className={styles.admitBtnButton}
                                                                            onClick={() => { approvingAdmittingCandidate() }}
                                                                        >
                                                                            Admit
                                                                        </Button>
                                                                    </Row>
                                                                </Col>
                                                            </div>
                                                        </div>
                                                    }

                                                        <div><p className={styles.waitingRoomTxt}>
                                                            Attendees&nbsp;{numberOfAttendees > 0 && `(${numberOfAttendees})`}
                                                        </p></div>
                                                    {((selectedTileID !== '-1') && isVideoEnabled) &&
                                                        (<Col sm={6} className={styles.oneRemoteVideoScreenSize} onClick={() => { updateSelectedAtendeeStatus('-1'); setSelectedTileID('-1'); }}>
                                                            <div className={styles.relativeDiv}>
                                                                <LocalVideo />
                                                                <div className={styles.absoluteDiv}>
                                                                    <RosterAttendee attendeeId={localAttendeeId} key={localAttendeeId} videoEnabled={true} name={getLoaclAttedndeedName(localAttendeeId)} subtitle='Reviewer'/>
                                                                </div>
                                                            </div>
                                                        </Col>)
                                                    }

                                                    {tiles.map(tileId => (selectedTileID !== tileId) && (
                                                        <Col sm={6} className={styles.oneRemoteVideoScreenSize}
                                                            onClick={() => {
                                                                updateSelectedAtendeeStatus(tileId);
                                                                setSelectedTileID(tileId);
                                                            }} >
                                                            <div className={styles.relativeDiv}>
                                                                <RemoteVideo tileId={tileId} key={tileId} />
                                                                <div className={styles.absoluteDiv}>
                                                                    <RosterAttendee attendeeId={getAttendeeId(tileId)} key={getAttendeeId(tileId)}  name={getAttendeeName(tileId)} subtitle={getAttendeeName(tileId)===props.candidateName?'Candidate':'Reviewer'}  />
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    ))}

                                                    <RosterGroup className={styles.attendeesbox}>{attendeeItems}</RosterGroup>

                                                    {(sharingAttendeeId && (selectedTileID !== '-2')) &&
                                                        (<Col sm={6} className={styles.oneRemoteVideoScreenSize} onClick={() => { updateSelectedAtendeeStatus('-2'); setSelectedTileID('-2'); }}>
                                                            <div className={styles.relativeDiv}>
                                                                <ContentShare nameplate={getLoaclAttedndeedName(sharingAttendeeId)} />
                                                            </div>
                                                        </Col>)
                                                    }

                                                </div>
                                            </Row>

                                            // chat
                                            : sidebarRosterType === 2 &&
                                            <div>
                                                <div><p className={styles.waitingRoomTxt}>Chat</p></div>
                                            
                                            <div className={styles.chatArea}>
                                                <div id="chatContainer" className={styles.chatContainer} ref={chatContainerRef}>
                                                    {chat_message.length > 0 &&
                                                        chat_message.map((values, index) => (
                                                            <ChatBox
                                                                variant={values.action}
                                                                senderName={values.senderName}
                                                                timestamp={values.createdDate}
                                                                keyIndex={index}
                                                                content={values.data}
                                                            />
                                                        ))
                                                    }
                                                </div>
                                                <div className={styles.textBoxContainer}>
                                                    <Formik
                                                    
                                                        validationSchema={schema}
                                                        initialValues={{}}
                                                        onSubmit={(values, resetForm) => sendChatData(values, resetForm)}>
                                                        {({
                                                            handleSubmit,
                                                            handleChange,
                                                            errors,
                                                            touched,
                                                            values
                                                        }) => (
                                                                <div className='ms-2 me-2'>
                                                                    <Form noValidate onSubmit={handleSubmit}>
                                                                        <div className={styles.sendMsgDiv}>
                                                                        <textarea
                                                                            className={styles.messageArea}
                                                                            id="messageTextarea"
                                                                            placeholder="Type a new message"
                                                                            name="message"
                                                                            onChange={handleChange}
                                                                            value={values.message || ''}
                                                                        />
                                                                        <button type="submit" className={styles.sendButton}>
                                                                            <svg
                                                                                width="27"
                                                                                height="24"
                                                                                viewBox="0 0 27 24"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M11.8762 12.001H5.21434M5.1118 12.3541L2.28364 20.8022C2.06146 21.4659 1.95036 21.7977 2.03009 22.0021C2.09932 22.1795 2.24802 22.3141 2.4315 22.3653C2.64278 22.4242 2.96191 22.2806 3.60015 21.9934L23.8418 12.8847C24.4648 12.6043 24.7763 12.4642 24.8726 12.2694C24.9562 12.1003 24.9562 11.9018 24.8726 11.7326C24.7763 11.5379 24.4648 11.3977 23.8418 11.1174L3.5931 2.00549C2.95678 1.71914 2.63861 1.57597 2.42754 1.6347C2.24423 1.68571 2.09555 1.8199 2.02608 1.99703C1.94608 2.201 2.05598 2.53213 2.27579 3.19438L5.11259 11.7412C5.15034 11.855 5.16922 11.9119 5.17667 11.97C5.18328 12.0216 5.18321 12.0739 5.17647 12.1255C5.16887 12.1836 5.14984 12.2405 5.1118 12.3541Z"
                                                                                    stroke="#3CBFDB"
                                                                                    strokeWidth="2.42249"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                        </button>
                                                                        </div>
                                                                        <ErrorMessage name="message" component="div" className={styles.errorMsg} />
                                                                    </Form>
                                                            </div>
                                                        )}
                                                    </Formik>
                                                </div>
                                            </div>
                                            </div>
                                        }

                                    </Col>
                                </Row>
                                <Row>
                                    {/* contollers */}
                                    <Col className={styles.controlsDiv}>
                                        <Row>
                                            <div className={styles.videoControlsDiv}>
                                            <AudioInputControl />
                                            <AudioOutputControl />
                                            <VideoInputBackgroundBlurControl onClick={handleVideoToggle}  />
                                            <div onClick={() => { setSelectedTileID('-2') }}><ContentShareControl /></div>
                                            <IconButton icon={<Phone />} onClick={endSession} className={styles.endMeetingBtn} />
                                            <IconButton
                                                icon={<i className="fas fa-expand-arrows-alt"></i>}
                                                onClick={fullScreenHandler.enter}
                                                className={styles.videoTileBtn}
                                            />
                                            </div>
                                        </Row>
                                    </Col>
                                    <Col sm={3} className={styles.rosterColumn}>
                                            <div className={styles.rosterBtn}>
                                                {sidebarRosterType === 1 ?
                                                    <IconButton
                                                        icon={<Attendees />}
                                                        badge={isCandidateWaitingToJoin &&<Badge value={1} className={styles.attendeesNoBadge} />}
                                                        selected={boolean('Selected', true)}
                                                        onClick={() => setSidebarRosterType(1)}
                                                    />
                                                    :
                                                    <IconButton
                                                        icon={<Attendees />}
                                                        badge={isCandidateWaitingToJoin &&<Badge value={1} className={styles.attendeesNoBadge} />}
                                                        onClick={() => handleClickAttendeeButton()}
                                                    />

                                                }

                                                <p className={styles.rosterBtnTxt}>Attendees</p>
                                            </div>
                                            <div className={styles.rosterBtn}>
                                                {sidebarRosterType === 2 ?
                                                    <IconButton
                                                        icon={<Chat />}
                                                        selected={boolean('Selected', true)}
                                                        onClick={() => handleClickChatButton()}
                                                          
                                                    />
                                                    :
                                                    <IconButton
                                                        icon={<Chat />}
                                                        badge={numberOfMessages !== 0 && <Badge value={numberOfMessages} className={styles.attendeesNoBadge} />}
                                                        onClick={() => handleClickChatButton()}

                                                    />
                                                }
                                                <p className={styles.rosterBtnTxt}>Chat</p>
                                            </div>
                                    </Col>
                                </Row>
                            </div>)
                            :
                            (applicationMeetingStatus == 2 || applicationMeetingStatus == 6) ?

                                (
                                    <Row className={styles.buttonContainingRow}>
                                        <Card className={styles.interviewBodyErrorMsgBox}>
                                            <p className={styles.interviewBodyErrorMsgText}>Something went wrong. Try refreshing the page</p>
                                        </Card>
                                    </Row>
                                ) : null

                }
            </div>

        </div>
        </BackgroundBlurProvider>

    )
}

export default InterviewView;
